export default __webpack_public_path__ + "static/media/basecamp.a5238654.svg";